module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAyklEQVQ4jZXRsUrCQRzA8Y9mqxJtbiEutjbX0NgD9AAurdFrOLn4Ii5iWz6ARBC0RauFEg1hdC3/4M+h97//wXHL98Pdj4NbHKuxpnhCNyduFucpFjjJBYp4gUEVmiOU9gpnKfAQgYANzuuAgC9c1QEB37iOwTIBAn4wLIPHChDwizto7RssWg2M0G7iMBNt8QavGU9a4eJfVoFn9MpXpcAMnfht73viMQ52DbOOwi1uUtOXwQcuUzF8FvEL+lWxIr7HUU4ME/k/7g/iZ2PBVi84YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/jt.png
// module id = i+fA
// module chunks = 1